"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SPRINTPAY_PAYMENT_CONFIG = void 0;
var storage_1 = require("./storage");
var constants_1 = require("./constants");
/**
 * INIT FUNCTION TO INITIALIZE THE CORE PROJECT
 * @param An object with {token: string, environment: string}
 **/
exports.SPRINTPAY_PAYMENT_CONFIG = function (options) {
    /**
     * SET CUSTOMER TOKEN
     **/
    storage_1.saveStorage('TOKEN', options.token);
    /**
     *
     * SETTING CORE-LIBRARIES
     **/
    setEnvironment(options.environment);
    setForteLibrary(options.environment);
};
/**
 * SET FORTE LIBRARY
 * @param environment
 */
var setForteLibrary = function (environment) {
    var env = storage_1.getStorage('ENVIRONMENT');
    var forteScript = document.createElement('script');
    forteScript.type = 'text/javascript';
    forteScript.src = env === '' ? 'https://api.forte.net/js/v1' : 'https://sandbox.forte.net/api/js/v1';
    document.body.appendChild(forteScript);
};
/**
 * SET LIBRARY ENVIRONMENT
 * @param environment
 *
 */
var setEnvironment = function (environment) {
    if (environment === constants_1.Constants.ENVIRONMENT_PROD) {
        storage_1.saveStorage('ENVIRONMENT', '');
    }
    if (environment === constants_1.Constants.ENVIRONMENT_STAGING) {
        storage_1.saveStorage('ENVIRONMENT', '-staging');
    }
    if (environment === constants_1.Constants.ENVIRONMENT_DEV) {
        storage_1.saveStorage('ENVIRONMENT', '-develop');
    }
    if (!environment) {
        storage_1.saveStorage('ENVIRONMENT', '-staging');
    }
};
//# sourceMappingURL=init.js.map